
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinsangli() {



const cardData = {
  keyword: 'Corporate Cab Services in Sangli MIDC',
  heading: 'eTravo: Reliable Corporate Cab Services in Sangli MIDC',
  headingDescription: `eTravo offers comprehensive corporate cab services in Sangli MIDC designed to support the transportation needs of businesses and their employees across the industrial region. Our service portfolio includes daily employee commutes, executive travel, client pickups, and airport transfers, ensuring every ride is comfortable, safe, and timely. Equipped with GPS-enabled vehicles and professional chauffeurs, we emphasize punctuality and customer satisfaction. Our flexible booking plans and customized cab rental solutions make eTravo the preferred choice for corporate clients in Sangli MIDC. We aim to enhance operational efficiency and provide a seamless travel experience that matches the fast-paced environment of this growing industrial hub.`,

  top: 'Key Industrial and Business Locations in Sangli MIDC Covered by eTravo',
  topPlaces: [
    {
      title: 'Sangli MIDC Industrial Estate',
      description: `The core industrial zone with numerous manufacturing and processing units. Our corporate cab services ensure that employees travel safely and punctually to and from work, with scheduled pickups tailored to shift timings.`
    },
    {
      title: 'Sangli Business Park',
      description: `A commercial hub hosting various offices and enterprises. We provide efficient business cab services for client visits, meetings, and daily office commutes to maintain productivity and professionalism.`
    },
    {
      title: 'Sangli Railway Station',
      description: `A major transport node in the region. eTravo offers seamless cab connectivity from this station for corporate clients and employees, easing the last-mile travel challenges.`
    },
    {
      title: 'Sangli Airport',
      description: `Our executive cab services ensure timely airport pickups and drop-offs with comfort and style, ideal for business travelers and VIP clients.`
    },
    {
      title: 'Local Industrial Complexes',
      description: `We provide tailored shuttle cab services for multiple industrial units, ensuring efficient group transportation and minimizing downtime during shift changes.`
    }
  ],

  services: [
    {
      name: 'Sangli MIDC Corporate Cab Rentals',
      description: `Customizable cab rental plans designed for businesses in Sangli MIDC, featuring flexible terms, competitive pricing, and dedicated service to meet all corporate transportation needs.`
    },
    {
      name: 'Employee Transport Cab Sangli MIDC',
      description: `Safe and reliable daily transport solutions for employees, with GPS tracking, well-maintained AC vehicles, and punctual service aligned with shift schedules.`
    },
    {
      name: 'Business Cab Services Sangli MIDC',
      description: `Professional business cab services tailored for client meetings, site visits, and other corporate travel requirements, available on-demand and with advance bookings.`
    },
    {
      name: 'Corporate Staff Cabs Sangli MIDC',
      description: `Multi-route staff cab services to efficiently handle large workforce commutes, ensuring timely pickup and drop-off while enhancing operational productivity.`
    },
    {
      name: 'Reliable Corporate Cab Service Sangli MIDC',
      description: `Trusted by numerous Sangli MIDC companies for its punctuality, safety, and high standards of vehicle upkeep, providing a hassle-free daily commute experience.`
    },
    {
      name: 'AC Corporate Cabs Sangli MIDC',
      description: `All vehicles in our fleet are fully air-conditioned, sanitized regularly, and maintained to provide a comfortable and hygienic environment for all passengers.`
    },
    {
      name: 'Staff Pickup and Drop Cab Sangli MIDC',
      description: `Round-the-clock employee transport services designed to accommodate different shift timings and emergency requirements with flexible scheduling.`
    },
    {
      name: 'Affordable Business Cab Rentals Sangli MIDC',
      description: `Budget-friendly cab rental options for startups and enterprises of all sizes, ensuring cost-effective transportation without compromising on service quality.`
    },
    {
      name: 'Executive Cab Services Sangli MIDC',
      description: `Premium cab services featuring luxury vehicles and professional chauffeurs, ideal for top-level executives, VIPs, and business guests.`
    },
    {
      name: 'Monthly Corporate Cab Rentals Sangli MIDC',
      description: `Monthly rental plans offering fixed routes and shift-based transport for employees, integrated with GPS tracking for transparency and safety.`
    },
    {
      name: 'Industrial Area Employee Transport Sangli MIDC',
      description: `End-to-end employee transport services designed to cover industrial clusters in Sangli MIDC, enhancing workforce mobility and efficiency.`
    },
    {
      name: 'Corporate Client Cabs Sangli MIDC',
      description: `Specialized cab services for corporate clients attending meetings and events, focusing on punctuality and a professional travel experience.`
    },
    {
      name: 'Business Meeting Cabs Sangli MIDC',
      description: `Flexible on-demand cabs available for urgent business meetings, site visits, and client appointments within Sangli MIDC and surrounding areas.`
    },
    {
      name: 'Sangli MIDC Industrial Area Cab Hire',
      description: `Dedicated cab hire services for industrial staff, supporting inter-site travel, shift changes, and corporate events with reliable transportation.`
    },
    {
      name: 'Corporate Shuttle Cabs Sangli MIDC',
      description: `Group shuttle services designed for efficient employee movement during corporate events, ensuring timely pickups and drop-offs with a professional fleet.`
    }
  ],

  tableData: [
    ['Sangli MIDC Corporate Cab Rentals', 'Employee Transport Cab Sangli MIDC'],
    ['Business Cab Services Sangli MIDC', 'Corporate Staff Cabs Sangli MIDC'],
    ['Reliable Corporate Cab Service Sangli MIDC', 'AC Corporate Cabs Sangli MIDC'],
    ['Staff Pickup and Drop Cab Sangli MIDC', 'Affordable Business Cab Rentals Sangli MIDC'],
    ['Executive Cab Services Sangli MIDC', 'Monthly Corporate Cab Rentals Sangli MIDC'],
    ['Industrial Area Employee Transport Sangli MIDC', 'Corporate Client Cabs Sangli MIDC'],
    ['Business Meeting Cabs Sangli MIDC', 'Sangli MIDC Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Sangli MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Efficient Corporate Cab Services for Sangli MIDC",
    "WhyChoosedescription": "eTravo delivers tailored cab solutions designed specifically for businesses in Sangli MIDC, a thriving industrial hub known for its diverse manufacturing and agro-based industries. Our services guarantee punctual and comfortable employee transportation, reducing commute-related stress and boosting overall operational efficiency. We understand the unique challenges of Sangli’s industrial landscape and offer customized routes and timings to suit your workforce needs."
  },
  {
    "WhyChooseheading": "Extensive Fleet to Match Diverse Corporate Needs",
    "WhyChoosedescription": "Our fleet consists of well-maintained sedans, SUVs, and multi-utility vehicles suitable for daily employee commutes, client visits, and inter-departmental transfers. Each vehicle is equipped with modern amenities and safety features to ensure a pleasant travel experience."
  },
  {
    "WhyChooseheading": "Professional Drivers with Local Route Expertise",
    "WhyChoosedescription": "Our drivers are trained professionals familiar with the Sangli MIDC area, including industrial zones, traffic patterns, and alternate routes. Their knowledge helps in timely arrivals and minimizing delays, ensuring reliability and safety for your employees."
  },
  {
    "WhyChooseheading": "Flexible Scheduling for Shifts and On-Demand Rides",
    "WhyChoosedescription": "We offer flexible booking options including fixed shifts, rotating schedules, and on-demand rides, enabling your company to manage transportation effectively regardless of changing workforce requirements."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking and Monitoring",
    "WhyChoosedescription": "With GPS-enabled vehicles, corporate clients can monitor rides in real-time, enhancing safety and operational transparency. Our system allows HR teams to track driver locations, estimated arrival times, and trip progress."
  },
  {
    "WhyChooseheading": "Transparent and Detailed Billing System",
    "WhyChoosedescription": "eTravo provides clear and detailed invoices, including trip logs and fare breakdowns, facilitating easy expense tracking, budget management, and reimbursement processes for corporate finance departments."
  },
  {
    "WhyChooseheading": "Strict Adherence to Safety and Hygiene Standards",
    "WhyChoosedescription": "We follow rigorous sanitization routines for our vehicles and enforce health protocols for drivers to maintain a safe and hygienic travel environment, prioritizing passenger well-being."
  },
  {
    "WhyChooseheading": "Dedicated Account Management Support",
    "WhyChoosedescription": "Each corporate client is assigned a dedicated account manager who offers personalized support, handles booking management, resolves queries promptly, and ensures a hassle-free transportation experience."
  }
]
}

const faqData = [
  [
    {
      question: "Which areas within Sangli MIDC are covered by your cab services?",
      answer: "We cover all major industrial sectors within Sangli MIDC and surrounding commercial areas to ensure seamless employee commute."
    },
    {
      question: "Can we schedule recurring rides for employees?",
      answer: "Yes, we support recurring ride scheduling tailored to your workforce shifts and timings."
    },
    {
      question: "Is monthly billing available for corporate clients?",
      answer: "Certainly, we provide monthly billing with detailed trip records for easy financial reconciliation."
    },
    {
      question: "Are your drivers trained in professional and safety standards?",
      answer: "Yes, our drivers receive regular training on corporate etiquette, safe driving, and passenger safety protocols."
    },
    {
      question: "How do you ensure passenger safety during commutes?",
      answer: "We use GPS tracking, maintain vehicles regularly, and enforce strict hygiene and safety measures."
    },
    {
      question: "Is there a dedicated support team for corporate clients?",
      answer: "Yes, a dedicated account manager is assigned to each corporate client for ongoing support and service customization."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Shirish Patil",
    designation: "Operations Head, Sangli Agro Industries",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s services have enhanced our employee transport reliability. Their professionalism and punctuality stand out.”"
  },
  {
    name: "Ms. Kavita Deshmukh",
    designation: "HR Manager, Vishwas Engineering",
    rating: [1, 1, 1, 1, 1],
    text: "“Flexible scheduling and excellent support from eTravo have made managing our transportation hassle-free.”"
  }
];





























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Sangli MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-sangli-midc.jpg",
  "description": "Reliable corporate cab service in Sangli MIDC offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-sangli-midc"
  }
};






    return (
        <div>

<Helmet>
  <title>Cab Service in Sangli MIDC | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Sangli MIDC for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/75.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinsangli;